<template>
    <main class="container content">
        <!-- <figure class="m-0 ">
            <img class="w-100" src="../../../assets/images/calendar/calendar-banner.png" alt="">
        </figure> -->
        <router-link to="/calendar" class="d-flex">


            <picture class="m-0 d-flex">
                <source media="(max-width:648px)" srcset="/assets/images/day-calendar/calendar-banner-month-mobile.gif">
                <img class="w-100" src="/assets/images/day-calendar/calendar-banner-month-des.gif" alt="">
            </picture>
        </router-link>
        <monthList :list="calendars" :currentMonthIndex="changeIndex" @changeSlide="goToSlide" />

        <section id="calendarSlider" ref="calendarSlider" class="product-details-img   position-relative ">
            <div class="product-details-l-img">
                <div v-if="calendars != null" class="">
                    <div class="btns">
                        <button class=" prev" @click="changeMonth('prev')">
                            <svg style="transform: rotate(180deg)" width="24" height="24" viewBox="0 0 24 24"
                                fill="#565656" xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M20.3284 11.0001V13.0001L7.50011 13.0001L10.7426 16.2426L9.32842 17.6568L3.67157 12L9.32842 6.34314L10.7426 7.75735L7.49988 11.0001L20.3284 11.0001Z"
                                    fill="#565656"></path>
                            </svg>
                            <span>ماه قبل</span>
                        </button>
                        <div class="d-flex align-items-center div-currentDate">
                            <span>امروز :</span>
                            <time :datetime="currentDateTime" @click="goToSlide(currentMonth)" v-if="currentDateTime"
                                class="currentDate">
                                {{ currentDateTime }}
                            </time>
                        </div>
                        <button class=" next" @click="changeMonth('next')">
                            <span>ماه بعد</span>

                            <svg width="24" height="24" viewBox="0 0 24 24" fill="#565656"
                                xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M20.3284 11.0001V13.0001L7.50011 13.0001L10.7426 16.2426L9.32842 17.6568L3.67157 12L9.32842 6.34314L10.7426 7.75735L7.49988 11.0001L20.3284 11.0001Z"
                                    fill="#565656"></path>
                            </svg>
                        </button>

                    </div>
                    <div class="days-container">

                        <div class="month-grid" v-if="calendars.length">
                            <template v-if="calendarsDays.first_blank > 0">

                                <div v-for="i in calendarsDays.first_blank" :key="`first_blank-${i}`"
                                    class="grid-item blank-image">
                                    <img src="../../../assets/images/day-calendar/2/blank1.png" :alt="`روز ${i + 1}`" />

                                </div>
                            </template>

                            <div :class="{ 'active-box': currentMonth == changeIndex && currentDay == i }"
                                class="box grid-item" v-for="i in calendarsDays.days"
                                :id="`box-${changeIndex + 1}-${i}`" :key="`index-${i}`" :ref="'dayCard' + i">
                                <img :src="`/assets/images/day-calendar/month${changeIndex + 1}/${i}.png`"
                                    :alt="`روز ${i + 1}`" />


                            </div>

                            <template v-if="calendarsDays.last_blank > 0">

                                <div v-for="i in calendarsDays.last_blank" :key="`last_blank-${i}`"
                                    class="grid-item blank-image">
                                    <img src="../../../assets/images/day-calendar/2/blank1.png" :alt="`روز ${i + 1}`" />

                                </div>
                            </template>


                        </div>
                    </div>
                </div>

            </div>
        </section>
    </main>
</template>
<script>
import monthList from "../components/calendar/monthList.vue";

// import fa_bkank1 from "@/assets/images/day-calendar/1/blank1.jpg"
// import fa_bkank2 from "@/assets/images/day-calendar/1/blank2.jpg"
// import fa_bkank3 from "@/assets/images/day-calendar/1/blank3.jpg"
// import fa_bkank4 from "@/assets/images/day-calendar/1/blank4.jpg"
import icon1 from "@/assets/images/calendar/icons/1.svg"
import icon2 from "@/assets/images/calendar/icons/2.svg"
import icon3 from "@/assets/images/calendar/icons/3.svg"
import icon4 from "@/assets/images/calendar/icons/4.svg"
import icon5 from "@/assets/images/calendar/icons/5.svg"
import icon6 from "@/assets/images/calendar/icons/6.svg"
import icon7 from "@/assets/images/calendar/icons/7.svg"
import icon8 from "@/assets/images/calendar/icons/8.svg"
import icon9 from "@/assets/images/calendar/icons/9.svg"
import icon10 from "@/assets/images/calendar/icons/10.svg"
import icon11 from "@/assets/images/calendar/icons/11.svg"
import icon12 from "@/assets/images/calendar/icons/12.svg"
import { Button } from "bootstrap";

export default {

    inject: ["mediaQueries"],
    data() {
        return {
            // changeIndex: 0,
            firstView: false,

            calendars: [
                {
                    first_blank: 0,
                    last_blank: 4,
                    icon: icon1,
                    title: 'فروردین',
                    days: 31

                },

                {
                    first_blank: 3,
                    last_blank: 1,
                    icon: icon2,
                    title: 'اردیبهشت',
                    days: 31

                },
                {
                    icon: icon3, title: 'خرداد', days: 31, first_blank: 6,
                    last_blank: 5,
                },
                {
                    icon: icon4, title: 'تیر', days: 31, first_blank: 2,
                    last_blank: 2,
                },
                {
                    icon: icon5, title: 'مرداد', days: 31, first_blank: 5,
                    last_blank: 6,
                },
                {
                    icon: icon6, title: 'شهریور', days: 31, first_blank: 1,
                    last_blank: 3,
                },
                {
                    icon: icon7, title: 'مهر', days: 30, first_blank: 4,
                    last_blank: 1,
                },
                {
                    icon: icon8, title: 'آبان', days: 30, first_blank: 6,
                    last_blank: 6,
                },
                {
                    icon: icon9, title: 'آذر', days: 30, first_blank: 1,
                    last_blank: 4,
                },
                {
                    icon: icon10, title: 'دی', days: 30, first_blank: 3,
                    last_blank: 2,
                },
                {
                    icon: icon11, title: 'بهمن', days: 30, first_blank: 5,
                    last_blank: 0,
                },
                {
                    icon: icon12, title: 'اسفند', days: 29, first_blank: 0,
                    last_blank: 6,
                },

            ],
            calendarsDays: []

        };
    },
    components: { monthList },
    computed: {
        currentDateTime() {
            return this.$store.getters["front/getCurrentDateTime"];
        },
        currentDay() {

            return this.$store.getters["front/getCurrentDay"];
        },
        changeIndex() {

            return this.$store.getters["front/getChangeIndexMonth"];
        },
        currentMonth() {

            // console.log(this.changeIndex, "this.changeIndex");

            return this.$store.getters["front/getCurrentMonth"];
        },
    },
    watch: {
        // changeIndex(newIndex) {
        //     if (this.currentMonth == newIndex) {

        //         this.scrollToDay(newIndex)
        //     }
        // },
        currentMonth(newMonth) {
            this.goToSlide(newMonth)
            this.calendarsDays = this.calendars[newMonth]
            // console.log("test");

        },
        currentDay(newDay) {


            this.scrollToDay(Number(newDay))

        }

    },
    mounted() {
        if (this.currentDateTime == null) {
            this.$store.dispatch("front/getCurrentDateTimeFromServer");
        }

        this.$nextTick(() => {
            // console.log(Number(this.currentMonth), "Number(this.currentMonth)222222");
            this.calendarsDays = this.calendars[this.currentMonth]
            // this.changeIndex = Number(this.currentMonth)
            this.$store.commit("front/setChangeIndexMonth", Number(this.currentMonth));
            this.goToSlide(Number(this.currentMonth))
        })
    },
    methods: {
        goToSlide(slideNumber) {
            // console.log(slideNumber, "slideNumber");
            this.$store.commit("front/setChangeIndexMonth", Number(slideNumber));
            // console.log(this.changeIndex, "changeIndex");

            // this.changeIndex = slideNumber
            this.$store.commit("front/setChangeIndexMonth", Number(slideNumber));
            if (this.currentMonth == this.changeIndex) {
                setTimeout(() => {

                    this.scrollToDay(Number(this.currentDay))
                }, 300);
            }

        },
        changeMonth(type) {
            let index = this.changeIndex
            // console.log(index, "indexindexindexindexindexindex");

            if (type == "next") {
                if (this.changeIndex < 12) {
                    // console.log("yes");

                    // this.changeIndex += 1
                    index += 1
                    this.$store.commit("front/setChangeIndexMonth", index);
                }
            } else {
                if (this.changeIndex > 0) {
                    index -= 1

                    this.$store.commit("front/setChangeIndexMonth", index);
                    if (this.currentMonth == index) {
                        setTimeout(() => {

                            this.scrollToDay(Number(this.currentDay))
                        }, 300);
                    }
                    // this.changeIndex -= 1
                }
            }
            // console.log(this.changeIndex, "indexindexindexindexindexindex");

        },
        scrollToDay(day) {
            const element = document.getElementById(`box-${this.changeIndex + 1}-${day}`)
            const filter = document.querySelector('.filter-calendar')
            const fixedHeader = document.querySelector('#fixedHeaderSection')


            if (element && filter) {
                const filterHeight = filter.offsetHeight
                const fixedHeaderHeight = fixedHeader.offsetHeight

                const y = element.getBoundingClientRect().top + window.pageYOffset - filterHeight - fixedHeaderHeight
                // const y = element.getBoundingClientRect().top

                window.scrollTo({
                    top: y,
                    behavior: "smooth"
                })
            }
        },

    },


};
</script>
<style scoped>
.active-box {
    background-color: unset;
    box-shadow: 0 0 15px 1px #0a3501;

}

.box {
    display: flex;
    border-radius: 26px;

}

.month-icon img {
    width: 100%;
    height: auto;
    object-fit: contain;
}

.month-grid {
    display: grid;
    grid-template-columns: repeat(7, 1fr);
    gap: 10px;
}



.currentDate {
    font-weight: 800;
    color: var(--color-theme);
    cursor: pointer;
}

img {
    width: 100%;
}

.content {
    margin-top: 40px;
}

.product-details-img {
    margin-top: 20px;
}

.btns {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-bottom: 16px;
}

.filter-calendar {
    list-style-type: none;
    display: flex;
    gap: 16px;
    overflow: auto;
    width: 100%;
    margin-top: 20px;
    margin-bottom: 0;
    position: sticky;

    z-index: 100;
    padding-block: 10px;
    background-color: white;
}

.filter-calendar button {
    background-color: unset;
}

.filter-calendar button img {
    min-width: 80px;
}

.figcaption {
    font-size: 14px;
    margin-top: 10px;
    font-weight: 800;
}

.div-currentDate {
    font-size: 18px;
    font-weight: bold;
    color: var(--color-theme);
    gap: 5px;
}

.btns .prev,
.btns .next {
    cursor: pointer !important;
    background: unset !important;
}

@media only screen and (max-width:640px) {
    .blank-image {
        display: none;
    }

    .currentDate {
        font-size: 14px;
    }

    .month-grid {

        grid-template-columns: repeat(3, 1fr);
        /* همون 7 ستون */
    }

    .content {
        margin-top: 20px;
    }

    .filter-calendar {
        padding-block: 6px;
        margin-top: 10px;

    }

    .figcaption {
        font-size: 13px;
    }

    .product-details-img {
        margin-top: 10px;
    }



    .btns .prev svg,
    .btns .next svg {
        width: 18px;
        height: 18px;
    }

    .btns .prev span,
    .btns .next span {
        font-size: 14px;
    }
}

@media only screen and (max-width:468px) {
    .month-grid {

        grid-template-columns: repeat(2, 1fr);
        /* همون 7 ستون */
    }
}
</style>
